<template>
  <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit" ref="reset-wizard"
               @on-complete="formSubmitted">
    <tab-content title="Step 1" class="mb-5" :before-change="validatLocationData">

      <!-- tab 1 content -->
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-full mt-5">
          <!--          <vs-input label="First Name" v-model="firstName" class="w-full" />-->
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
          <div class="chat__chats-list mb-8">
            <h3 class="text-primary mb-5 px-4">How do you want to add your {{ $t('menu.students.name') }} and {{ $t('menu.users.name') }}?</h3>
            <ul class="chat__active-chats">

              <li class="cursor-pointer li-style mt-2 p-4">
                <div class="chat__contact flex items-center px-2 pt-4 pb-2"
                     :class="{'bg-primary-gradient text-white shadow-lg': false}">
                  <div class="contact__container w-full flex items-center justify-between overflow-hidden">
                    <div class="contact__avatar mr-1">
                      <h5 class="font-semibold">Location:</h5>
                    </div>
                    <div class="contact__info flex flex-col truncate w-5/6">
                      <vs-select
                         v-on:input="selectLocation"
                        class=" w-5/6"
                        placeholder="Select Location"
                        autocomplete
                        v-model="setLocation">
                        <vs-select-item :key="index" :value="item" :text="item.name" v-for="item,index in locations" />
                      </vs-select>
                    </div>

                  </div>


                </div>
              </li>
              <li class="cursor-pointer li-style mt-2 p-4">
                <div class="chat__contact flex items-center px-2 pt-4 pb-2"
                     :class="{'bg-primary-gradient text-white shadow-lg': false}">
                  <div class="contact__avatar mr-1">
                    <vs-checkbox v-model="createStudents" @input="setValuestudent(createStudents)"></vs-checkbox>
                  </div>
                  <div class="contact__container w-full flex items-center justify-between overflow-hidden">
                    <div class="contact__info flex flex-col truncate w-5/6">
                      <h5 class="font-semibold">Add directly into KVAdmin</h5>
                      <span class="truncate">Add {{ $t('student.titlesmall') }} and {{ $t('user.titlesmall') }} information one by one. Fast and easy!</span>
                    </div>

                  </div>
                </div>
              </li>
              <li class="cursor-pointer li-style mt-2 p-4">
                <div class="chat__contact flex items-center px-2 pt-4 pb-2"
                     :class="{'bg-primary-gradient text-white shadow-lg': false}">
                  <div class="contact__avatar mr-1">
                    <vs-checkbox v-model="uploadFile" @input="setValue(uploadFile)"></vs-checkbox>
                  </div>
                  <div class="contact__container w-full flex items-center justify-between overflow-hidden">
                    <div class="contact__info flex flex-col truncate w-5/6">
                      <h5 class="font-semibold">Upload a roster</h5>
                      <span class="truncate">Send us a file of information and we will input it for you</span>
                    </div>

                  </div>
                </div>
              </li>

            </ul>
          </div>
        </div>
        <div class="vx-col md:w-1/4 w-full mt-5">

        </div>
      </div>
    </tab-content>

    <!-- tab 2 content -->
    <tab-content v-if="uploadFile" title="Step 2" class="mb-5" :before-change="setStudentTabActive">

      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-full mt-5">
          <!--          <vs-input label="First Name" v-model="firstName" class="w-full" />-->
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
          <div class="chat__chats-list mb-8">
            <h3 class="text-primary mb-5 px-4">Upload your roster</h3>
            <h6 class="ml-4">Send us a list of your {{ $t('menu.students.name') }} and {{ $t('menu.users.name') }} in the attached template format.
              <!-- <a :href="filePath+filename" download>Download Template</a> -->
              <a  class="text-primary cursor-pointer" @click="downloadFile('on-boarding/template.xlsx')">Download Template</a>
              
            </h6>
            <!--            <vs-upload :action="filePath"/>-->
            <div id="div-with-loading">
              <input class="ml-10 mt-10 mb-6 hidden" type="file" ref="file" @change="uploadCsv" accept=".xlsx , .csv">
              <vs-button class="mr-4 ml-4 mt-10 mb-6" @click.native="$refs.file.click()">Upload File</vs-button>
              <span>{{ GetFileName }}</span>
            </div>

            <p class="text-danger ml-2" v-if="Students.length == 0 && ifFileDataNotFound">No Data Found</p>
          </div>
        </div>
        <!--        <div class="vx-col md:w-1/4 w-full mt-5">-->
        <!--               <vx-card class="p-2">-->

        <!--                    <img class="mx-auto mb-6 block responsive w-10 h-10"  src="@/assets/images/pages/lamp.svg" />-->
        <!--                    <div class="text-center">-->
        <!--                        <p class="text-grey">For faster turnaround time, you can use our roster upload template!</p><br>-->
        <!--                        <a  :href="filePath+filename" download>Download Template</a>-->

        <!--                    </div>-->
        <!--                </vx-card>-->
        <!--        </div>-->
        <div class="preview-data-div">
          <ul class="ml-5" v-if="UploadingErrors !=null && ShowUploadinErrors" v-for="(Errors,ind) in UploadingErrors">
            <li style="list-style:circle" class="text-danger" v-html="Errors">{{ UploadingErrors }}</li>
          </ul>
          <table class="preview-data">
            <tr v-if="ShowPreview">
              <td class="preview-data-td">#</td>
              <td class="preview-data-td">First Name</td>
              <td class="preview-data-td">Last Name</td>
              <td class="preview-data-td">Program</td>
              <td class="preview-data-td">{{ $t('user.alert_title') }}1 First Name</td>
              <td class="preview-data-td">{{ $t('user.alert_title') }}1 Last Name</td>
              <td class="preview-data-td">{{ $t('user.alert_title') }}1 Email</td>
              <td class="preview-data-td">{{ $t('user.alert_title') }}1 Phone</td>
              <td class="preview-data-td">{{ $t('user.alert_title') }}2 First Name</td>
              <td class="preview-data-td">{{ $t('user.alert_title') }}2 Last Name</td>
              <td class="preview-data-td">{{ $t('user.alert_title') }}2 Email</td>
              <td class="preview-data-td">{{ $t('user.alert_title') }}2 Phone</td>


            </tr>
            <tr v-if="ShowPreview" v-for="(getStudent, index) in Students" :key="index">
              <td class="preview-data-td">{{ index + 1 }}</td>
              <td class="preview-data-td">{{ getStudent.fname }}</td>
              <td class="preview-data-td">{{ getStudent.lname }}</td>
              <td class="preview-data-td">{{ getProgram(getStudent.program) }}</td>
              <td class="preview-data-td" v-if="getStudent.Users[0]">{{ getStudent.Users[0].fname }}</td>
              <td class="preview-data-td" v-if="getStudent.Users[0]">{{ getStudent.Users[0].lname }}</td>
              <td class="preview-data-td" v-if="getStudent.Users[0]">{{ getStudent.Users[0].email }}</td>
              <td class="preview-data-td" v-if="getStudent.Users[0]">{{ getStudent.Users[0].phone }}</td>
              <td class="preview-data-td" v-if="getStudent.Users[1]">{{ getStudent.Users[1].fname }}</td>
              <td class="preview-data-td" v-if="getStudent.Users[1]">{{ getStudent.Users[1].lname }}</td>
              <td class="preview-data-td" v-if="getStudent.Users[1]">{{ getStudent.Users[1].email }}</td>
              <td class="preview-data-td" v-if="getStudent.Users[1]">{{ getStudent.Users[1].phone }}</td>

            </tr>

          </table>

        </div>
      </div>

    </tab-content>    <!-- tab 2 content -->
    <tab-content v-if="createStudents" title="Step 2" class="mb-5" :before-change="validateStudentsInputData">
      <div class="vx-row">
        <div class="vx-col md:w-1/6 w-full mt-5">
        </div>
        <div class="vx-col md:w-1/1 w-full mt-5 pl-24  pr-24">
          <div class="chat__chats-list mb-8">
            <h3 class="text-primary mb-5 px-4">Add {{ $t('menu.students.name') }}</h3>
            
            <h6 class="ml-5 mb-5">Please enter the {{ $t('student.titlesmall') }}s details carefully in the following input boxes.
            </h6>
            <vs-table :data="Students">

              <template slot="thead">
                <vs-th>Id</vs-th>
                <vs-th>First Name</vs-th>
                <vs-th>Last Name</vs-th>
                <vs-th>Program</vs-th>
                <vs-th></vs-th>
              </template>

              <template>
                <!--                {{Students}}-->
                <vs-tr v-for="(student, index) in Students">
                  <vs-td class="pt-0" style="padding-top: 0px;">
                    <span>{{ index + 1 }}</span>
                  </vs-td>
                  <vs-td>
                    <vs-input v-model="student.fname" class="inputx" placeholder="First Name"/>
                  </vs-td>
                  <vs-td>
                    <vs-input v-model="student.lname" class="inputx" placeholder="Last Name"/>
                  </vs-td>
                  <vs-td>
                    <vs-select
                      class="selectExample"
                      placeholder="Program"
                      autocomplete
                      v-model="student.program">
                      
                      <vs-select-item :value="item.id" :text="item.name" v-for="item in Programs"/>
                    </vs-select>
                    <!--                    <v-select style="width: 200px" placeholder="Program" label="name"  v-model="student.program":options="Programs" />-->


                  </vs-td>
                  <vs-td>
                    <span class="danger" v-if="index > 0" @click.stop="removeStudentRow(index)"
                          style="color:red;cursor: pointer">x</span>

                  </vs-td>
                </vs-tr>
                <div>
                  <vs-button class="text-center mt-2" @click.native="addNewStudentRow()" size="small" icon-pack="feather"
                             icon="icon-plus"></vs-button>
                </div>
              </template>
            </vs-table>

          </div>
        </div>
        <div class="vx-col md:w-1/8 w-full mt-5">

        </div>
      </div>


    </tab-content>
    <tab-content title="Step 3" class="mb-5" :before-change="UserDataValidation">
       <h3 class="text-primary mb-5 px-4">Add {{ $t('menu.users.name') }}</h3>
            <h6 class="ml-5 mb-5">{{ $t('menu.users.name') }} can manage their {{ $t('student.titlesmall') }}s, view or edit different settings of the {{ $t('student.titlesmall') }}s and watch cameras.
            </h6>
      <vs-row v-for="(smsstudent, index) in Students" :key="index" class="p-1">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
          <vs-chip v-if="smsstudent.image">
            <vs-avatar :src="img_cdn+smsstudent.image"/>
            {{ smsstudent.fname }} {{ smsstudent.lname }} <br>
            {{ smsstudent.program.name }}
          </vs-chip>
          <vs-chip v-else>

            <vs-avatar/>
            {{ smsstudent.fname }} {{ smsstudent.lname }}
            <br>
            {{smsstudent.program.name}}
          </vs-chip>
        </vs-col>
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
          <vs-row >
            <div v-for="(user, indexx) in smsstudent.Users" :key="indexx" class="w-full">
              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                <vs-input class="w-full" label-placeholder="First Name" v-model="user.fname" />
              </vs-col>
              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                <vs-input class="w-full" label-placeholder="Last Name" v-model="user.lname" />
              </vs-col>
              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                <vs-input  class="w-full"  type="email" label-placeholder="Email" v-model="user.email" @input="acceptEmail(user.email,index,indexx)" :name="'email '+String(indexx+1)" v-validate="'email'"/>
                <span class="text-danger text-sm mt-20" style="position: absolute" v-show="errors.has('email '+String(indexx+1))">{{ errors.first('email '+String(indexx+1)) }}</span>

              </vs-col>
              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                <vs-input @input="acceptNumber(user.phone,index,indexx)" class="w-full" label-placeholder="Phone Number" v-model="user.phone" />
                <p class="hidden">{{acceptNumber(user.phone,index,indexx)}}</p>
                <span class="danger mt-3 ml-1" @click="removeNumber(index,indexx)"  style="color:red ;cursor: pointer">x</span>
              </vs-col>
              <vs-col vs-offset="6"  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" v-if="user.check > 0" class="text-danger text-sm" >Email has already been taken!
              </vs-col>
              <vs-col v-if="user.phone.length > 0 &&  user.phone.length < 14"  vs-type="flex" style="float: right" vs-justify="center" vs-align="center" vs-w="3" class="text-danger text-sm"> Invalid phone number format.
              </vs-col>
            </div>
            <vs-col vs-offset="10" vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="2">
              <vs-button color="primary" size="small" @click.native="addNewNumber(index)" class="mt-1">
                <feather-icon icon="PlusIcon" svgClasses="h-2 w-2"/>
              </vs-button>
            </vs-col>

          </vs-row>
        </vs-col>
        <vs-divider />
      </vs-row>


    </tab-content>
    <tab-content title="Step 4" class="mb-5 ">
       <h3 class="text-primary mb-5 px-4">Notification Settings</h3>
      <h6 class="ml-5 mb-5"> What kind of invitation notifications, do you want to send?</h6>

      
      <vs-row v-for="(smsstudent, index) in Students" :key="index" class="p-1">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center"  vs-w="2">
          <vs-chip v-if="smsstudent.image">
            <vs-avatar :src="img_cdn+smsstudent.image"/>
            {{smsstudent.fname}} {{smsstudent.lname}} <br>
            {{smsstudent.program.name}}
          </vs-chip>
          <vs-chip v-else>
            <vs-avatar/>
            {{smsstudent.fname}}  {{smsstudent.lname}}
            <br>
            {{smsstudent.program.name}}
          </vs-chip>
        </vs-col>
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
          <vs-row >
            <div v-for="(user, indexx) in smsstudent.Users" :key="indexx" class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-2 ml-2">
              <vx-card>
                 <div class="text-center">
                        <h6>{{user.fname}} {{user.lname}}</h6>
                         <small>{{user.email}}</small><br v-if="user.email">
                         <small>{{user.phone}}</small>
                    </div>
                <div>
                  <span class="inline-flex text-center">
                    <vs-checkbox v-model="user.sms_notif" v-if="user.phone"></vs-checkbox>
                     <vs-checkbox v-else v-model="user.sms_notif" disabled="true"></vs-checkbox>
                    <small class="mt-1">Send invite sms</small>
                    </span>
                     <span class="inline-flex text-center">
                     <vs-checkbox v-model="user.email_notif" v-if="user.email"></vs-checkbox>
                     <vs-checkbox v-else v-model="user.email_notif" disabled="true"></vs-checkbox>
                    <small class="mt-1">Send invite email</small>
                    </span>
                </div>
                <!-- <div class="flex justify-between text-center mt-1">
                        <span >
                            <vs-switch v-model="user.sms_notif" v-if="user.phone"/>
                            <vs-switch v-else v-model="user.sms_notif" disabled="true"/>
                            <span class="inline-flex">
                              <message-square-icon size="1x" class="custom-class"></message-square-icon>
                            <small class="text-grey ml-1">SMS</small>
                            </span>
                        </span>
                  <span >
                            <vs-switch v-model="user.email_notif" v-if="user.email"/>
                             <vs-switch v-else v-model="user.email_notif" disabled="true"/>
                              <span class="inline-flex">
                            <mail-icon size="1x" class="custom-class"></mail-icon>
                            <small class="text-grey ml-1"> EMAIL</small>
                            </span>
                        </span>
                </div> -->
              </vx-card>
            </div>

          </vs-row>
        </vs-col>
        <vs-divider />
      </vs-row>

    </tab-content>

  </form-wizard>

</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {DROPDOWN_ALL_LOCATIONS, ALL_PROGRAMS_QUERY, SAVE_BOARDING_DATA, SINGLE_USER_BY_EMAIL, UPLOAD_CSV,DOWNLOAD_TICKET_ATTACHMENT,GET_PROGRAM_BY_LOCATION} from '@/graphql'
import vSelect from 'vue-select'
import {MailIcon, MessageSquareIcon, PhoneIcon} from 'vue-feather-icons'

export default {
  components: {
    FormWizard,
    TabContent,
    'v-select': vSelect,
    MailIcon,
    PhoneIcon,
    'message-square-icon':MessageSquareIcon
  },
  data () {
    return {

      filePath: process.env.VUE_APP_FILES_CDN_LINK,
      filename: 'template.xlsx',
      GetFileName: '',
      createStudents: true,
      uploadFile: false,
      ifCreate: false,
      ifUploadFile: false,
      ifFileDataNotFound: false,
      ShowUploadinErrors: false,
      eventLocation: 'san-francisco',
      status: 'plannning',
      UploadingErrors: [],
      setLocation: null,
      dataProgram: [],
      Programs: [],
      locations: [],
      ShowPreview:false,
      Students: [
        {
          'id': '',
          'fname': '',
          'lname': '',
          'program': '',
          'Users': [
            {
              'fname': '',
              'lname': '',
              'email': '',
              'phone': '',
              'check': 0,
              'sms_notif':false,
              'email_notif':false

            }
          ],
          'location':[
            {
              'id': '',
              'name': ''
            }
          ]
        }
      ],

      StudentsFileData: [
        {
          'id': '',
          'fname': '',
          'lname': '',
          'program': '',
          'Users': [
            {
              'fname': '',
              'lname': '',
              'email': '',
              'phone': '',
              'check': 0,
              'sms_notif':false,
              'email_notif':false

            }
          ],
          'location':[
            {
              'id': '',
              'name': ''
            }
          ]
        }
      ],
       activeLoading:false,

    }
  },
  methods: {
    getProgram (id) {
      for (let i = 0; i < this.Programs.length; i++) {
        if (this.Programs[i].id == id) {
          return this.Programs[i].name
        }
      }
    },
    openLoadingInDiv () {
      this.$vs.loading({
        type: 'sound',
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    uploadCsv (input) {
      this.ShowPreview = false
      this.ShowUploadinErrors = false
      this.Students = this.StudentsFileData
      const largeFile = []

      const formData = []
      for (let i = 0; i < this.$refs.file.files.length; i++) {
        const limit = 1024 * 1024 * 2048
        if (this.$refs.file.files[i].size > limit) {
          largeFile.push(this.$refs.file.files[i].name)
        } else {
          const file = this.$refs.file.files[i]
          formData.push(file)
          this.GetFileName = this.$refs.file.files[i].name

        }
        this.largeFile = largeFile

      }
      this.openLoadingInDiv()
      this.$apollo
        .mutate({
          mutation: UPLOAD_CSV,
          variables: {
            file: formData
          }
        })
        .then(response => {
          this.ShowPreview = true

          const newStudents = []
          const files = response.data.uploadCsv.data
          for (let i = 0; i < files.length; i++) {
            delete files[i].__typename
            delete files[i].program.__typename
            for (let u = 0; u < files.length; u++) {
              delete files[i].Users[u].__typename
            }
            newStudents.push(files[i])
          }
          this.Students = newStudents
          this.createStudents = false
          this.uploadFile = true
          this.UploadingErrors = []
          if (this.Students.length == 0) {
            this.ifFileDataNotFound = true
          }
          if (response.data.uploadCsv.errors.length > 0) {
            this.UploadingErrors = response.data.uploadCsv.errors
          }
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
        }).catch(error => {
          this.UploadingErrors=[];
          this.UploadingErrors.push("Failed to upload check your data format")
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.ifFileDataNotFound = false
          this.$vs.notify({
            title: 'Invalid Data',
            text: 'Failed to upload check your data format',
            position: 'top-right',
            color: 'danger'
          })
        })
    },
    validatLocationData () {

      let flag = false
      if (this.setLocation) {
        flag = true
      } else {
        this.$vs.notify({
          title: 'Validation failed',
          text: 'Location is required',
          position: 'top-right',
          color: 'danger'
        })
        flag = false
        return false
      }


      if (flag) {
        return true
      }

    },
    setStudentTabActive () {

      if (this.UploadingErrors.length > 0) {
        this.ShowUploadinErrors = true
        this.createStudents = false
        this.uploadFile = true
        return false
      } else {

        this.ShowUploadinErrors = false
        this.createStudents = true
        this.uploadFile = false

        let flag = false
        if (this.Students.length > 0) {
        for (let i = 0; i < this.Students.length; i++) {
          if (this.Students[i].fname.length > 0 && this.Students[i].lname.length > 0 && this.Students[i].program) {
            this.Students[i].location = this.setLocation
            flag = true
          } else {
            flag = false
            return flag
          }
        }
      }
      return flag
}
    },
    validateStudentsInputData () {

      let flag = false

      if (this.Students.length > 0) {
        for (let i = 0; i < this.Students.length; i++) {
          if (this.Students[i].fname.length > 0 && this.Students[i].lname.length > 0 && this.Students[i].program) {
            this.Students[i].location = this.setLocation
            flag = true
          } else {
            this.$vs.notify({
              title: this.$t('menu.students.name'),
              text: `Fields are requied at row ${i + 1} `,
              position: 'top-right',
              color: 'danger'
            })
            flag = false
            return false
          }


        }
        if (flag) {

          return true
        }
      }
    },
    UserDataValidation () {
      if (!this.errors.any()) {
        let flag = false
        let emailflag = true
        const Emails = []
        if (this.Students.length > 0) {
          for (let i = 0; i < this.Students.length; i++) {
            if (this.Students[i].Users.length > 0) {

              for (let j = 0; j < this.Students[i].Users.length; j++) {
                if (this.Students[i].Users[j].fname.length > 0 && this.Students[i].Users[j].lname.length > 0 && this.Students[i].Users[j].check == 0 && ((this.Students[i].Users[j].phone.length == 14 || this.Students[i].Users[j].phone.length == 0) && ((this.Students[i].Users[j].email.length > 0) || (this.Students[i].Users[j].phone.length == 14 )))) {
                  if (this.Students[i].Users[j].email.length > 0) {
                    Emails.push(this.Students[i].Users[j].email)
                  }
                  flag = true
                } else {

                  this.$vs.notify({
                    title: this.$t('menu.students.name'),
                    text: `Fields are requied at ${  this.$t('student.alert_title')  } ${i + 1} ${  this.$t('user.alert_title')  } ${j + 1} `,
                    position: 'top-right',
                    color: 'danger'
                  })
                  flag = false
                  return false
                }
              }
            }
             else{
              this.$vs.notify({
              title: 'Error',
              text: `Add at least one ${  this.$t('user.titlesmall')  }`,
              position: 'top-right',
              color: 'danger'
            })
            return false
            }
          }
          emailflag = this.checkIfDuplicateExists(Emails)

          if (flag === true && emailflag === false) {
            for (let i = 0; i < this.Students.length; i++) {
              for (let j = 0; j < this.Students[i].Users.length; j++) {
                if (this.Students[i].Users[j].email.length == 0) {
                  this.Students[i].Users[j].email_notif = false
                } else {
                  this.Students[i].Users[j].email_notif = true
                }
                if (this.Students[i].Users[j].phone.length == 0) {
                  this.Students[i].Users[j].sms_notif = false
                } else {
                  this.Students[i].Users[j].sms_notif = true
                }
              }
            }
            return true
          } else {
            this.$vs.notify({
              title: 'Error',
              text: 'Fields have duplicate emails',
              position: 'top-right',
              color: 'danger'
            })
            return false
          }
        }
      } else {
        this.$vs.notify({
          title:'Error',
          text: 'Fields have invalid email formate',
          position: 'top-right',
          color: 'danger'
        })
        return false
      }

    },
    checkIfDuplicateExists (w) {
      return new Set(w).size !== w.length
    },
    formSubmitted () {
      this.loader()
      this.$apollo
        .mutate({
          mutation: SAVE_BOARDING_DATA,
          variables: {
            students:this.Students
          }
        })
        .then(response => {
          if (response.data.saveBoardingData.status === 'Success') {
            this.StatusSuccess(response.data.saveBoardingData.message, response.data.saveBoardingData.color)
            this.$refs['reset-wizard'].reset()
            this.Students = [
              {
                'id': '',
                'fname': '',
                'lname': '',
                'program': '',
                'Users': [
                  {
                    'fname': '',
                    'lname': '',
                    'email': '',
                    'phone': '',
                    'check': 0,
                    'sms_notif':false,
                    'email_notif':false

                  }
                ],
                'location':[
                  {
                    'id': '',
                    'name': ''
                  }
                ]
              }
            ],
            this.setLocation = null
            this.ShowPreview = false
            this.activeLoading = false
            this.$vs.loading.close()
          }
          else{
            this.activeLoading = false
            this.$vs.loading.close()
            this.StatusSuccess(response.data.saveBoardingData.message, response.data.saveBoardingData.color)
          }

        }).catch(error => {
        // this.SendSMSbtn=false
          console.log(error)
          this.$vs.notify({
            title: 'Success',
            text: 'Sent Successfully!',
            color: 'success',
            position: 'top-right'
          })
          this.$refs['reset-wizard'].reset()
          this.Students = this.StudentsFileData
          this.setLocation = null
          this.activeLoading = false
          this.$vs.loading.close()
        })
      return true
    },
    setValue (val) {
      this.createStudents = !val
      this.Students = this.StudentsFileData
      this.GetFileName = ''
    },
    setValuestudent (val) {
      this.uploadFile = !val
      this.Students = this.StudentsFileData
      this.GetFileName = ''
    },
    addNewStudentRow () {
      this.Students.push(
        {
          'id': '',
          'fname': '',
          'lname': '',
          'program': '',
          'Users':[
            {
              'fname': '',
              'lname': '',
              'email': '',
              'phone': '',
              'check': 0,
              'sms_notif':false,
              'email_notif':false

            }
          ],
          'location':[
            {
              'id': '',
              'name': ''
            }
          ]
        }
      )
    },
    StatusSuccess (status, color) {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text:   status,
        color,
        position: 'top-right'
      })

    },
    addNewNumber (index) {
      this.Students[index].Users.push(
        {
          fname:'',
          lname:'',
          email:'',
          phone:'',
          check: 0,
          sms_notif:false,
          email_notif:false
        }
      )
    },
    removeStudentRow (index) {
      this.Students.splice(index, 1)
    },

    removeNumber (sindex, uindex) {
      this.Students[sindex].Users.splice(uindex, 1)
    },
    acceptNumber (phone, index, indexx) {
      const x = phone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

      this.Students[index].Users[indexx].phone = !x[2]
        ? x[1]
        : `(${  x[1]  }) ${  x[2]  }${x[3] ? `-${  x[3]}` : ''}`
    },
    acceptEmail (email, index, indexx) {
      this.$apollo
        .mutate({
          mutation: SINGLE_USER_BY_EMAIL,
          variables: {
            email
          }
        })
        .then(response => {
          if (response.data.userByEmail.length > 0) {
            this.Students[index].Users[indexx].check = 1
          } else {
            this.Students[index].Users[indexx].check = 0
          }
        }).catch(error => {
          console.log(error)
          this.Students[index].Users[indexx].check = 0
        })
    },
    getLocations () {
      this.$apollo
        .mutate({
          mutation: DROPDOWN_ALL_LOCATIONS
        })
        .then(response => {
          this.locations = response.data.dropdownlocations

          // for (let i = 0; i < this.locations.length; i++) {
          //   delete this.locations[i].phone
          //   delete this.locations[i].email
          //   delete this.locations[i].address
          //   delete this.locations[i].pin_url
          //   delete this.locations[i].latitude
          //   delete this.locations[i].longitude
          //   delete this.locations[i].schedule_id
          //   delete this.locations[i].timezone
          //   delete this.locations[i].cameras
          //   delete this.locations[i].managers
          //   delete this.locations[i].schedule
          //   is_signup":false,"signup_code":null,"billing":false,"active":false

          // }

        })
    },
    selectLocation(event){
      if(event){
        // if(!event.billing){
        //     this.$vs.notify({
        //     title: 'Error',
        //     text: 'This record is disabled because of its locations’ billing problems.',
        //     color: 'danger',
        //     position: 'top-right'
        //   })
        //    this.dataLocation='';
        //  }
        //  else{
            this.getProgramByLocation(event);
        //  }
      }
      else{
        this.Programs = []
      }
    },
    getProgramByLocation(location){
      this.$apollo
        .mutate({
          mutation: GET_PROGRAM_BY_LOCATION,
          variables: {
            location_id:location.id
          }
        })
        .then(response => {
          if (response) {
            console.log(response)
            this.Programs = response.data.location_programs
          }
        }).catch(error => {
          console.log(error)
        })
      },
      downloadFile (file) {
      this.$apollo
        .mutate({
          mutation: DOWNLOAD_TICKET_ATTACHMENT,
          variables: {
            file
          }
        })
        .then(response => {
          window.location = response.data.downloadTicketAttachment
        }
        )
    },
     loader () {
      this.activeLoading = true
      this.$vs.loading({
        type:'sound'
      })
    },
  },

  created () {

    this.getLocations()
    // this.$apollo
    //   .mutate({
    //     mutation: ALL_PROGRAMS_QUERY
    //   })
    //   .then(response => {
    //     this.Programs = response.data.programs
    //     for (let i = 0; i < this.Programs.length; i++) {
    //       delete this.Programs[i].color_code
    //       delete this.Programs[i].location

    //     }
    //   })
  }
}
</script>
<style lang="scss">
.li-style:hover {

  border: 1px solid;
  border-color: #5463d6;

}

.li-style {
  border: 1px solid #d5d9df;

}

@import "@/assets/scss/vuexy/apps/chat.scss";
</style>
<style>
.wizard-progress-with-circle {
  display: none;

}

.preview-data, .preview-data-td {
  border: 1px solid black;
  border-collapse: collapse;
  background: white;

}

.preview-data-td {
  padding: 1px;
  font-size: 10px;
}

.preview-data-div {
  margin: auto;
  justify-content: center;
}

</style>
